import { render, staticRenderFns } from "./CongratulationScreenWorkday.vue?vue&type=template&id=4c44e32c&scoped=true"
import script from "./CongratulationScreenWorkday.vue?vue&type=script&lang=js"
export * from "./CongratulationScreenWorkday.vue?vue&type=script&lang=js"
import style0 from "./CongratulationScreenWorkday.vue?vue&type=style&index=0&id=4c44e32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44e32c",
  null
  
)

export default component.exports